export default pos => regex => str => (str.match(regex) || [])[pos];
